// extracted by mini-css-extract-plugin
export var gameContainer = "index-module--gameContainer--ujVJG";
export var large = "index-module--large--PyyN3";